import React from 'react';
import { FieldValues } from 'react-hook-form';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import SelectField from 'shared/components/formFields/select-field';

type Props = {
  label: string;
  options: { key: string; value: string }[];
  field: FieldValues;
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
  startAdornment?: React.ReactNode;
};

const MultiSelectField = ({ label, options, field, error, helperText, disabled = false, startAdornment }: Props): React.JSX.Element => {
  const renderSelectedOptions = (selected: string[]): string =>
    options
      .filter((o) => selected.includes(o.key))
      .map((o) => o.value)
      .join(', ');

  return (
    <SelectField
      multiple
      {...field}
      label={label}
      variant="outlined"
      renderValue={(selected) => renderSelectedOptions(selected as string[])}
      error={error}
      helperText={helperText}
      disabled={disabled}
      startAdornment={startAdornment}
    >
      {options.map((option) => (
        <MenuItem key={`option-${option.key}`} value={option.key}>
          <Checkbox sx={{ padding: '0 9px' }} checked={field.value.includes(option.key)} />
          <ListItemText primary={option.value} />
        </MenuItem>
      ))}
    </SelectField>
  );
};

export default MultiSelectField;
